<div [formGroup]="dateForm" class="main-container">
    <div
        [ngClass]="
            styleType === 'rounded'
                ? 'tv-round-input-extensible-no-label-no-border'
                : styleType === 'squared-small'
                    ? 'tv-square-input-for-date-pickers-small-no-label'
                    : showFloatLabel
                        ? 'tv-square-input-for-date-pickers-with-label'
                        : 'tv-square-input-for-date-pickers-no-label'
        ">
        <mat-form-field class="tv-date-range-picker">
            <mat-label>{{ label }}</mat-label>
            <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
            <input matInput [matDatepicker]="picker" formControlName="date" />
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="tv-input-error-message" *ngIf="dateError">
            <mat-icon class="tv-input-error-icon">error</mat-icon>
            <span class="tv-input-error-text">Veuillez renseigner la date</span>
        </div>
    </div>
</div>
